import React from 'react';
import { useToolStore } from '../../store/useToolStore';
import { Upload, Maximize } from 'lucide-react';

export const MaterialOverride: React.FC = () => {
    const { materialOverrideParams, setMaterialOverrideParams } = useToolStore();

    // Helper to update specific fields
    const updateParams = (updates: Partial<typeof materialOverrideParams>) =>
        setMaterialOverrideParams({ ...materialOverrideParams, ...updates });

    return (
        <div className="space-y-2">
            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider">Material Override</h3>
            <div className="bg-gray-800 p-4 rounded-lg space-y-4">
                <div className="text-xs text-gray-400 mb-2">Select a surface on the canvas, then apply a material.</div>

                {/* Texture Upload (Placeholder) */}
                <div
                    className={`border-2 border-dashed rounded-lg p-4 flex flex-col items-center justify-center transition-colors cursor-pointer h-24 ${materialOverrideParams.textureUrl
                            ? 'border-indigo-500 text-indigo-300 bg-indigo-500/10'
                            : 'border-gray-600 text-gray-500 hover:border-gray-400 hover:text-gray-300'
                        }`}
                    onClick={() => {
                        // In real app this would open file picker. For now, simulated toggle.
                        updateParams({ textureUrl: materialOverrideParams.textureUrl ? null : 'simulated_texture.jpg' });
                    }}
                >
                    <Upload size={20} className="mb-2" />
                    <span className="text-xs">{materialOverrideParams.textureUrl ? 'Texture Uploaded' : 'Upload Texture'}</span>
                </div>

                {/* Scale Control */}
                <div className="space-y-2">
                    <div className="flex items-center justify-between text-xs text-gray-400">
                        <div className="flex items-center space-x-1">
                            <Maximize size={12} />
                            <span>Texture Scale</span>
                        </div>
                        <span>{materialOverrideParams.textureScale}x</span>
                    </div>
                    <input
                        type="range"
                        min="0.1"
                        max="5"
                        step="0.1"
                        value={materialOverrideParams.textureScale}
                        onChange={(e) => updateParams({ textureScale: Number(e.target.value) })}
                        className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-green-500"
                    />
                </div>

                <button
                    className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded transition-colors"
                >
                    Apply to Surface
                </button>
            </div>
        </div>
    );
};
